import React from "react";

const RecycleBin = () => (
  <svg
    className="recycle-bin-icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    height="15px"
    width="15px"
    viewBox="0 0 512 512"
  >
    <g>
      <g>
        <path
          d="M331.636,69.818V0H180.364v69.818h-128v128h34.909V512h337.455V197.818h34.909v-128H331.636z M215.273,34.909h81.455
v34.909h-81.455V34.909z M389.818,477.091H122.182V197.818h267.636V477.091z M424.727,162.909H87.273v-58.182h337.455V162.909z"
        />
      </g>
    </g>
    <g>
      <g>
        <rect x="168.727" y="256" width="34.909" height="162.909" />
      </g>
    </g>
    <g>
      <g>
        <rect x="308.364" y="256" width="34.909" height="162.909" />
      </g>
    </g>
    <g>
      <g>
        <rect x="238.545" y="256" width="34.909" height="162.909" />
      </g>
    </g>
  </svg>
);

export default RecycleBin;
